import { useCallback, useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import { setAuthenticated } from 'app/auth/slices';
import { LocalStorageService } from 'services';
import { Current } from 'app/userPreferences/types';
import { getRandomNumber } from 'utils/utils';

const useLogout = () => {
  const dispatch = useAppDispatch();

  const goToLoginPage = useCallback(() => {
    const { conversionId } = LocalStorageService.get<Current>('current') || {};

    LocalStorageService.clear();

    LocalStorageService.set('current', {
      conversionId,
    });

    window.location.href = '/login';
  }, []);

  const logout = useCallback(() => {
    dispatch(setAuthenticated(false));
    localStorage.setItem('logout', `logout${getRandomNumber()}`);
    goToLoginPage();
  }, [dispatch, goToLoginPage]);

  useEffect(() => {
    window.addEventListener(
      'storage',
      (event) => {
        if (event.key === 'logout') {
          goToLoginPage();
        }
      },
      false,
    );
  }, [goToLoginPage]);

  return {
    logout,
  };
};

export default useLogout;
